export function getView(insurance) {
  return (
    !insurance.is_primary &&
    !!insurance.insured.insurance_subscription.insurance_plan
      .tx_category_coverages.ortho_coverages.cob_type
  )
}
